<template>
  <div class="wrapper">
    <div class="back" @click="backBtn">
      <img alt="backicon" src="../../assets/img/back-icon.svg" />
    </div>
    <div class="logo">
      <img alt="logo" :src="referalLogo" />
    </div>
    <h1 class="title">Присоединяйся и получай бонусы!</h1>

    <div class="formBox">
      <p>
        Данный номер телефона будет использован для входа в мобильное приложение
      </p>
      <span class="number">{{ userData.stringNumber }}</span>
    </div>

    <div class="btnsWrapper">
      <p>Скачайте приложение и авторизуйтесь в нем по номеру указанному выше</p>
      <div class="btns">
        <button
          @click="clickBtn(item)"
          v-for="item of formatedButtonLinks"
          :key="item.type"
        >
          <img alt="iconbtn" :src="item.logo" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReferalStores",

  data() {
    return {
      referalLogo: process.env.VUE_APP_REFERAL_LOGO,
    };
  },

  props: {
    buttonLinks: {
      type: Array,
      default: () => [],
    },

    userData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    formatedButtonLinks() {
      return this.buttonLinks.filter(
        (item) => item.url && item.url.toLowerCase() !== "false"
      );
    },
  },

  methods: {
    backBtn() {
      this.$emit("back");
    },

    async clickBtn(item) {
      window.open(item.url);
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.back {
  position: absolute;
  cursor: pointer;
}

.logo {
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  margin: 27px auto 0 auto;

  border-radius: 16px;
  overflow: hidden;

  img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.title {
  margin-top: 48px;
}

.formBox {
  margin: 24px 6px 0 6px;
  padding: 16px;
  border-radius: 16px;
  outline: 1px solid black;

  p {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #25282b;
  }

  .number {
    display: block;
    text-align: center;
    margin: 16px auto 0 auto;
    font-size: 24px;
    font-weight: 500;
  }
}

.btnsWrapper {
  margin: 36px 6px 0 6px;
  padding: 24px 16px;
  height: 100%;

  p {
    font-size: 14px;
    line-height: 21px;
    font-weight: 700;
    text-align: center;
    color: #25282b;
  }

  .btns {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    padding: 16px;
    border-radius: 16px;
    box-shadow: 0px 24px 48px 0 rgba(0, 0, 0, 0.2);
  }

  button {
    height: 43px;
    border-radius: 8px;
    border: none;
    background: black;
    color: white;
    cursor: pointer;
  }
}
</style>
